// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Collapse_collapse__2RSPz","content":"Collapse_content__1JJEq","open":"Collapse_open__1dynh","header":"Collapse_header__1Gtnv"};